export default __webpack_public_path__ + "mt-logo-g.8253ca4e2922e2518376177884f83efc.8253ca4e2922e2518376177884f83efc.svg";